import React from "react";
import styles from "./DigitalCinema.module.scss";

import { messages } from "../Delivery.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";

export const DigitalCinema: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <div className={styles.container}>
      <div key={1} className={styles.carouselItem}>
        <h3 className={styles.title}>{formatMessage(messages.digitalCinemaTitle)}</h3>
        <ui.Scrollbars>
          <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.digitalCinemaDescription1) }}></p>
        </ui.Scrollbars>
      </div>
    </div>
  );
};
